module.exports = __webpack_public_path__ + "img/wx_qr.134ec322.jpg";